import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Stars from "src/react/components/stars";

const imageOptions = "?fl=progressive";

const reviewsCoUkImage = `https://images.ctfassets.net/itvcls9imtx8/1WDrJTmYLKYAwIcMSWKQUU/809d782b6fffc2973529cddeea8b4b90/reviews-co-uk-logo.png${imageOptions}`;
const facebookImage = `https://images.ctfassets.net/itvcls9imtx8/20738XMgS4couAsy2i0usE/53bb74db869e00f6d53edea81b76aa67/Facebook-wordmark.png${imageOptions}`;

class Reviews extends Component {
  static propTypes = {
    starSize: PropTypes.number.isRequired,
  };

  static defaultProps = {
    starSize: 32,
  };

  render() {
    const { starSize, ...props } = this.props;
    return (
      <Flex {...props}>
        <FlexItem
          as="a"
          tracking="custom"
          trackingOptions={{ buttonLabel: `reviewFacebook` }}
          href="https://www.facebook.com/pg/CornerStoneHQ/reviews/"
          target="_blank"
          rel="noopener"
        >
          <Image
            src={facebookImage}
            alt="Cornerstone on Facebook reviews"
            width="527"
            height="109"
          />
          <Stars value={4.3} size={starSize} style={{ margin: "0 auto" }} />
          <Text>4.3/5.0 from 1200+ reviews</Text>
        </FlexItem>
        <FlexItem
          as="a"
          tracking="custom"
          trackingOptions={{ buttonLabel: `reviewReviews` }}
          href="https://www.reviews.co.uk/company-reviews/store/cornerstone"
          target="_blank"
          rel="noopener"
        >
          <Image
            src={reviewsCoUkImage}
            alt="Cornerstone on Reviews.co.uk"
            width="690"
            height="109"
          />
          <Stars value={4.6} size={starSize} style={{ margin: "0 auto" }} />
          <Text>4.6/5.0 from 3000+ reviews</Text>
        </FlexItem>
      </Flex>
    );
  }
}

export default Reviews;

const Flex = styled.section`
  text-align: center;
  margin: auto;
  @media (min-width: 600px) {
    display: flex;
    justify-content: center;
  }
  ${({ css }) => css};
`;

const FlexItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 15px 20px;
  max-width: 250px;
  margin: 0 auto;
  @media (min-width: 600px) {
    height: 150px;
    align-items: center;
    justify-content: flex-end;
    margin: 0 7%;
  }
`;

const Text = styled.p`
  font-size: 14px;
  margin-bottom: 0;
`;

const Image = styled.img`
  width: 100%;
  max-width: 200px;
  height: auto;
  display: flex;
  align-items: center;
  margin: 0 auto;
`;
